import React from 'react';
import { useTranslation } from 'react-i18next';
import { PaymentType } from '../../api/payamigo';
import CpfField from '../cpfField';
import Field from '../UI/field';
import DropdownAnimation from '../UI/dropdownAnimation';

interface IPayAmigoFormFieldsProps {
  // CPF
  cpf: string;
  cpfError: string | null;
  onCpfChange: (value: string) => void;
  
  // PIX Key (for withdrawal)
  pixKey: string;
  pixKeyError: string | null;
  onPixKeyChange: (value: string) => void;
  
  // Currency
  selectedCoin: string;
  coins: Array<{ key: string; value: string }>;
  onCoinChange: (newValue: { key: string; value?: string }) => void;
  
  // Amount
  amount: string;
  amountError: string | null;
  onAmountChange: (value: string) => void;
  
  // Payment type
  paymentType: PaymentType;
  
  // Disabled state
  disabled?: boolean;
}

const PayAmigoFormFields: React.FC<IPayAmigoFormFieldsProps> = ({
  cpf,
  cpfError,
  onCpfChange,
  pixKey,
  pixKeyError,
  onPixKeyChange,
  selectedCoin,
  coins,
  onCoinChange,
  amount,
  amountError,
  onAmountChange,
  paymentType,
  disabled = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className="form-fields">
      <CpfField
        className="cpf-field"
        label={t('PAY_AMIGO.CPF_LABEL', { defaultValue: 'CPF' })}
        value={cpf}
        onChange={onCpfChange}
        error={cpfError || undefined}
        disabled={disabled}
      />

      {paymentType === PaymentType.Withdrawal && (
        <Field
          className="pix-key-field"
          label={t('PAY_AMIGO.PIX_KEY_LABEL', { defaultValue: 'PIX Key (phone number)' })}
          value={pixKey}
          onChange={onPixKeyChange}
          placeholder={t('PAY_AMIGO.PIX_KEY_PLACEHOLDER', { defaultValue: 'Enter your PIX key' })}
          error={pixKeyError || undefined}
          disabled={disabled}
        />
      )}

      <DropdownAnimation
        wrapperClass="coin-dropdown"
        label={t('PAY_AMIGO.COIN_LABEL', { defaultValue: 'Select Currency' })}
        selectedValue={selectedCoin || undefined}
        options={coins}
        onChange={onCoinChange}
        disabled={disabled}
      />

      <Field
        className="amount-field"
        label={t('PAY_AMIGO.AMOUNT_LABEL', { defaultValue: 'Amount' })}
        value={amount}
        onChange={onAmountChange}
        placeholder="0.00"
        error={amountError || undefined}
        disabled={disabled}
      />
    </div>
  );
};

export default PayAmigoFormFields;

